import { render } from "./base-accordion-item.vue?vue&type=template&id=01a4b6e8"
import script from "./base-accordion-item.vue?vue&type=script&lang=js"
export * from "./base-accordion-item.vue?vue&type=script&lang=js"

import "./base-accordion-item.vue?vue&type=style&index=0&id=01a4b6e8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__